export default __webpack_public_path__ + "static/8504-7bb43549616e58b45961da347801f145.jpg";